import { Button } from '@components/MovingBorders';
import { MY_WORK_EXPERIENCE } from '@constants/index';
import { motion } from 'framer-motion';

const WorkExperience = () => {
  return (
    <div className="min-h-screen flex flex-col items-center py-20 text-center" id="experience">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="font-sans text-3xl lg:text-4xl font-bold z-10 mb-4"
      >
        My work <span className="text-purple">experience</span>
      </motion.h1>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
        className="text-gray-400 max-w-xl mb-12 text-sm lg:text-base"
      >
        Diverse roles across the full software development lifecycle, from backend systems to team leadership
      </motion.p>

      <div className="w-full mt-6 grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 grid-cols-1 gap-8 px-4">
        {MY_WORK_EXPERIENCE.map((work, index) => (
          <motion.div
            key={work.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
            className="flex-1 text-white"
          >
            <Button duration={Math.floor(Math.random() * 10000) + 10000}>
              <div className="flex flex-col p-6 lg:p-8 gap-4 h-full text-left">
                <div className="flex items-center gap-4">
                  <img src={work.icon} alt={work.title} className="w-16 h-16 lg:w-20 lg:h-20 object-contain" />
                  <h3 className="text-lg lg:text-xl font-bold leading-tight">{work.title}</h3>
                </div>

                <p className="text-sm text-gray-300 leading-relaxed">{work.description}</p>

                <ul className="space-y-2 mt-2">
                  {work.highlights.map((highlight, i) => (
                    <li key={i} className="text-xs text-gray-400 flex items-start gap-2">
                      <span className="text-purple-400 mt-0.5 shrink-0">✦</span>
                      <span>{highlight}</span>
                    </li>
                  ))}
                </ul>

                <div className="flex flex-wrap gap-1.5 mt-auto pt-4 border-t border-white/10">
                  {work.techStack.map((tech) => (
                    <span
                      key={tech}
                      className="text-[10px] px-2 py-0.5 rounded-full bg-purple-500/10 text-purple-300 border border-purple-500/20"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </Button>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default WorkExperience;
